/**
 * Visibility for pc_only/ppc_only/returning slides is settled in
 * sections/header-announcements.liquid — those blocks are never rendered, so
 * they cannot flash. `first_time` is the only browser-side rule: the inline
 * script in that section decides it before first paint and the stylesheet keeps
 * losing slides hidden, so by the time this module runs nothing is visible that
 * shouldn't be.
 *
 * What is left is bookkeeping: a hidden slide is still a slide to Swiper, which
 * would rotate onto a blank panel. Drop those slides from the DOM. Swiper
 * initialises on requestIdleCallback after a CDN import, so this comfortably
 * lands first and the carousel is built with the right count.
 */

function pruneHiddenSlides() {
  // Theme editor: every block stays visible and editable; Liquid stamps the grant.
  if (window.Shopify?.designMode) return;

  const bar = document.querySelector('[data-announcement-bar]');
  if (!bar) return;

  // First-time visitor: every rendered slide is eligible, nothing to prune.
  if (window.maFirstTimeVisitor) return;

  const slides = bar.querySelectorAll('[data-visibility="first_time"]');
  if (slides.length === 0) return;

  slides.forEach(/** @param {Element} slide */ slide => slide.remove());

  reinitCarousels(bar);
}

/** @param {Element} bar */
function reinitCarousels(bar) {
  const carousels = bar.querySelectorAll('carousel-component');
  carousels.forEach(/** @param {Element} carousel */ carousel => {
    const swiperWrapper = carousel.querySelector('.swiper-wrapper');
    if (!swiperWrapper) return;

    const remainingSlides = swiperWrapper.querySelectorAll('.swiper-slide');

    if (remainingSlides.length === 0) {
      carousel.closest('[data-js-announcement-carousel]')?.remove();
      return;
    }

    /** @type {any} */
    const comp = carousel;

    // Only relevant if Swiper won the race (theme editor re-renders, slow idle).
    if (remainingSlides.length === 1 && comp.swiper) {
      comp.swiper.autoplay?.stop();
    }

    if (comp.swiper) {
      comp.swiper.update();
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', pruneHiddenSlides);
} else {
  pruneHiddenSlides();
}
